import proj4 from 'proj4';
import { register } from 'ol/proj/proj4';
import { get as getProjection, transform } from 'ol/proj';

/**
 * S-JTSK / Krovak East North. Several of the best archive sources publish only in
 * this CRS; OpenLayers reprojects their tiles client-side into the Web Mercator
 * view, which is the reason this project uses OpenLayers at all (SPEC §3).
 */
export const SJTSK = 'EPSG:5514';

const SJTSK_DEF =
  '+proj=krovak +lat_0=49.5 +lon_0=24.8333333333333 +alpha=30.2881397527778 ' +
  '+k=0.9999 +x_0=0 +y_0=0 +ellps=bessel ' +
  '+towgs84=589,76,480,0,0,0,0 +units=m +no_defs';

/** Valid area of the Czech grid, in S-JTSK metres — matches the CENIA tile cache. */
const SJTSK_EXTENT: [number, number, number, number] = [-925000, -1444000, -400000, -920000];
const SJTSK_WORLD: [number, number, number, number] = [12.09, 48.55, 18.86, 51.06];

let registered = false;

export function registerProjections(): void {
  if (registered) return;
  proj4.defs(SJTSK, SJTSK_DEF);
  register(proj4);
  const p = getProjection(SJTSK);
  if (p) {
    p.setExtent(SJTSK_EXTENT);
    p.setWorldExtent(SJTSK_WORLD);
  }
  registered = true;
}

/** Scale denominator to metres/pixel, using the OGC 0.28 mm pixel. */
export function scaleToResolution(scaleDenominator: number): number {
  return scaleDenominator * 0.00028;
}

export function toLonLat(coord: number[]): [number, number] {
  const [lon, lat] = transform(coord, 'EPSG:3857', 'EPSG:4326');
  return [lon, lat];
}

export function fromLonLatToSJTSK(lon: number, lat: number): [number, number] {
  const [x, y] = transform([lon, lat], 'EPSG:4326', SJTSK);
  return [x, y];
}
